<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><b>The Forest Lord</b></p>
<p class="ORIM-Chapter-Subtitle--Body-">Book One of the Fane Series</p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-1">Susan Krinard</span></p>
<p class="ORIM-Author-Name--Front-Matter- _idGenParaOverride-1"><span class="CharOverride-2"><img alt="logo" src="image/logo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ForestLord.vue?04b45cf8